import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  recentlyViewed: [],
  maxItems: 10,
};

const staySmallSmallRecentlyViewedSlice = createSlice({
  name: 'staySmallSmallRecentlyViewed',
  initialState,
  reducers: {
    addItemToRecentlyViewed(state, action) {
      const newProduct = action.payload;
      const filteredItems = state.recentlyViewed.filter(
        (item) => item.apartmentID !== newProduct.apartmentID
      );
      const updatedItems = [newProduct, ...filteredItems].slice(
        0,
        state.maxItems
      );
      state.recentlyViewed = updatedItems;
    },
    clearRecentlyViewed(state) {
      state.recentlyViewed = [];
    },
  },
});

export const { addItemToRecentlyViewed, clearRecentlyViewed } =
  staySmallSmallRecentlyViewedSlice.actions;

// Selector: use the key you register in your store, e.g. staySmallSmallRecentlyViewed
export const getRecentlyViewedApartments = (state) =>
  state.staySmallSmallRecentlyViewed?.recentlyViewed;

export default staySmallSmallRecentlyViewedSlice.reducer;